import { graphql } from "../gql";

export const setNegotiationClaimStatesMutationDoc = graphql(`
  mutation setNegotiationClaimStates($input: SetNegotiationClaimStatesInput!) {
    setNegotiationClaimStates(input: $input) {
      negotiationClaimStates {
        batchClaim {
          batchClaimStateById {
            claimAuditType
            clientSignOffClaimState
            determinedAdjustedAllowedAmount
            determinedClientSavings
            determinedDiscrepantAmount
            disputedFindingClaimState
            documentationClaimState
            id
            invoiceClaimState
            isProviderActive
            isRealized
            negotiationClaimState
            onHoldClaimState
            potentialAdjustedAllowedAmount
            potentialClientSavings
            potentialDiscrepantAmount
            providerSignOffClaimState
            reported
            workflowClaimState
          }
          id
        }
      }
    }
  }
`);
